module.exports = __webpack_public_path__ + "assets/img/6.0753f85a.png";